import React from 'react';
import {
    matchPath,
    useLocation
} from 'react-router-dom';

import { useGroupByIdSelector } from '../../user-profiles';
import { RouteContainer } from '../helpers/styled';
import { ROUTES } from '../routes';
import { LandingContent } from './components/landing-content';
import { LandingTitle } from './components/landing-title';
import {
    Container,
    Landing
} from './landing.styled';

/**
 * Manages left bar nav click when group has more than one module.
 */
const LandingRoute = () => {
    const groupId = useLandingByGroupIdParam();
    const selectedModuleIds = useGroupByIdSelector(groupId || '');

    if (!groupId) {
        // TODO not found view
        return <div data-testid={'no-group-found'} />;
    }

    return (
        <RouteContainer>
            <Landing data-groupid={groupId} data-testid={'landing-route'}>
                <Container>
                    <LandingTitle title={groupId} />
                    <LandingContent selectedModuleIds={selectedModuleIds} />
                </Container>
            </Landing>
        </RouteContainer>
    );
};

function useLandingByGroupIdParam (): string | null {
    const location = useLocation();
    const match = matchPath<{ groupId: string }>(location.pathname, {
        path: ROUTES.landingByGroupId,
        exact: true
    });
    const { groupId } = match?.params || {};

    return typeof groupId === 'string' ? groupId : null;
}

export { LandingRoute as default };
